import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Paper,
} from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';

const IMG = "/NBSIPSQR.png";

const PaymentQRCode: React.FC = () => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <QrCodeIcon color="primary" />
          <Typography variant="h6" fontWeight="bold">
            QR Code Payment
          </Typography>
        </Box>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Scan this QR code to make the payment.
        </Typography>

        <Paper 
          sx={{ 
            p: 2, 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            flex: 1,
          }}
        >
          <Box
            component="img"
            src={IMG}
            alt="QR Code Payment"
            sx={{
              width: '100%',
              maxWidth: 250,
              height: 'auto',
              aspectRatio: '1 / 1',
              objectFit: 'contain',
              display: 'block',
            }}
            onError={(e) => {
              // Fallback if image doesn't exist
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent) {
                const errorMsg = document.createElement('div');
                errorMsg.textContent = 'QR code image not found. Please upload the QR code image to /public/';
                errorMsg.style.padding = '20px';
                errorMsg.style.color = '#d32f2f';
                parent.appendChild(errorMsg);
              }
            }}
          />
        </Paper>
      </CardContent>
    </Card>
  );
};

export default PaymentQRCode;

